var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146,
    height: 136,
    viewBox: "0 0 146 136",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5067,
    cy: 26.5067,
    r: 26.0067,
    fill: "white",
    stroke: "#282750"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8892 37.7221L13.4775 28.8503L17.144 23.694L24.5584 29.0044L34.9603 15.2754L40.0028 19.0996L25.8892 37.7221Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8217 10.0371C55.5466 10.0371 47.2087 19.217 47.2087 30.5354C47.2087 41.8539 55.5375 51.0338 65.8217 51.0338C76.0969 51.0338 93.3338 40.6759 93.3338 29.3483C93.3338 23.1861 82.6784 13.7979 78.7676 10.0371C78.7676 10.0371 70.5021 10.0371 65.8217 10.0371Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.1715,
    cy: 30.5504,
    r: 15.275,
    fill: "#282750"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.034 134.13L122.034 82.2676L21.5732 82.2676L21.5732 134.13L122.034 134.13Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.99 99.2142H97.1347C96.6006 99.2142 96.166 98.7792 96.166 98.2446V95.6982C96.166 95.1635 96.6006 94.7285 97.1347 94.7285H109.99C110.524 94.7285 110.959 95.1635 110.959 95.6982V98.2446C110.959 98.7792 110.524 99.2142 109.99 99.2142Z",
    fill: "#282750"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.357 84.9525V82.9316L22.0726 82.9316V84.9525L121.357 84.9525Z",
    fill: "#FEF6E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.361 82.9316H119.342V133.335H121.361V82.9316Z",
    fill: "#FEF6E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0708 92.2828L61.4272 96.4785L63.3672 103.726L79.0107 99.5304L77.0708 92.2828Z",
    fill: "#FEF6E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2373 134.132L84.2373 82.2695L21.5634 82.2695L21.5634 134.132H84.2373Z",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.003 130.1L145.003 120.068L32.7457 120.068L32.7457 130.1L145.003 130.1Z",
    fill: "#282750"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.219 135.002L139.219 115.156L38.5315 115.156L38.5315 135.002L139.219 135.002Z",
    fill: "#A1D5FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5276 115.154V116.93H137.142V135H139.215V115.154H38.5276Z",
    fill: "#FEF6E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5276 132.935V117.23C38.5276 116.088 39.451 115.164 40.5916 115.164H137.151C138.292 115.164 139.215 116.088 139.215 117.23V132.935C139.215 134.077 138.292 135.001 137.151 135.001H40.5916C39.451 135.001 38.5276 134.077 38.5276 132.935Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0418 46.8359C71.9958 47.6696 69.7597 48.1318 67.415 48.1318C65.7583 48.1318 64.1559 47.9053 62.635 47.4703",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8207 43.8441C63.8207 43.8441 74.2135 49.0729 74.8292 48.8826C75.4448 48.6923 84.6788 39.9746 84.6788 39.9746C84.6788 39.9746 86.8063 45.1037 87.4762 45.6021C88.1552 46.1096 118.7 58.2709 118.7 58.2709L120.999 57.8087C122.357 57.5368 123.371 59.023 122.629 60.192L127.092 73.8123H113.974L109.394 68.8644C108.588 67.9944 107.411 67.5595 106.234 67.6954L102.332 68.1485C101.943 66.2998 100.223 65.0402 98.3489 65.2124L95.9226 65.4389L95.8955 65.3302C95.5062 63.4453 93.759 62.1766 91.8488 62.385L89.2506 62.666C89.2506 62.666 86.3808 58.3615 83.9365 60.8898L81.0124 65.6655L77.6627 63.6175L77.9343 82.2581H64.8075L48.9104 72.7158L54.8492 57.0022L50.0058 50.84L51.3366 46.309H64.4273",
    fill: "#F8E6EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8207 43.8441C63.8207 43.8441 74.2135 49.0729 74.8292 48.8826C75.4448 48.6923 84.6788 39.9746 84.6788 39.9746C84.6788 39.9746 86.8063 45.1037 87.4762 45.6021C88.1552 46.1096 118.7 58.2709 118.7 58.2709L120.999 57.8087C122.357 57.5368 123.371 59.023 122.629 60.192L127.092 73.8123H113.974L109.394 68.8644C108.588 67.9944 107.411 67.5595 106.234 67.6954L102.332 68.1485C101.943 66.2998 100.223 65.0402 98.3489 65.2124L95.9226 65.4389L95.8955 65.3302C95.5062 63.4453 93.759 62.1766 91.8488 62.385L89.2506 62.666C89.2506 62.666 86.3808 58.3615 83.9365 60.8898L81.0124 65.6655L77.6627 63.6175L77.9343 82.2581H64.8075L48.9104 72.7158L54.8492 57.0022L50.0058 50.84L51.3366 46.309H64.4273",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6253 46.085L63.1225 50.8425L67.9659 57.0047L62.0271 72.7183L77.9242 82.2606L90.7794 63.62L94.129 65.668L97.0531 60.8923C99.4974 58.355 102.367 62.6685 102.367 62.6685L104.965 62.3876C106.876 62.1791 108.623 63.4569 109.012 65.3327L109.039 65.4596L111.466 65.233C113.349 65.0518 115.06 66.3205 115.449 68.1691L119.351 67.716C120.528 67.5801 121.704 68.0151 122.51 68.885L127.091 73.8329L135.746 60.2127C136.488 59.0437 135.465 57.5575 134.116 57.8294L131.817 58.2915L99.4522 39.4878L95.5051 29.7461C95.5051 29.7461 88.317 46.1393 87.7014 46.3296C87.0858 46.5199 71.4513 49.2476 71.4513 49.2476",
    fill: "#F8E6EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8659 51.2467C69.8659 51.2467 85.4914 48.5281 86.107 48.3287C86.2337 48.2925 86.6502 47.5494 87.2114 46.4076C84.4955 46.9422 71.4502 49.2168 71.4502 49.2168L64.6242 46.0723L63.8638 48.4828L69.8659 51.2467Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1854 65.6445L77.7876 82.1828L77.9234 82.2643L89.3211 65.7261L89.1854 65.6445Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4586 62.9176L93.8652 65.5094L94.1187 65.6634L96.1104 62.4102C95.9021 62.537 95.6758 62.6911 95.4586 62.9176Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.115 57.8157L131.815 58.2779L99.4508 39.4741L95.5037 29.7324C95.5037 29.7324 94.9968 30.8833 94.2454 32.5779L97.8575 41.495L130.222 60.2987L132.521 59.8365C133.879 59.5647 134.893 61.0508 134.151 62.2198L126.9 73.6199L127.081 73.8102L135.735 60.1899C136.496 59.03 135.473 57.5438 134.115 57.8157Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6253 46.085L63.1225 50.8425L67.9659 57.0047L62.0271 72.7183L77.9242 82.2606L90.7794 63.62L94.129 65.668L97.0531 60.8923C99.4974 58.355 102.367 62.6685 102.367 62.6685L104.965 62.3876C106.876 62.1791 108.623 63.4569 109.012 65.3327L109.039 65.4596L111.466 65.233C113.349 65.0518 115.06 66.3205 115.449 68.1691L119.351 67.716C120.528 67.5801 121.704 68.0151 122.51 68.885L127.091 73.8329L135.746 60.2127C136.488 59.0437 135.465 57.5575 134.116 57.8294L131.817 58.2915L99.4522 39.4878L95.5051 29.7461C95.5051 29.7461 88.317 46.1393 87.7014 46.3296C87.0858 46.5199 71.4513 49.2476 71.4513 49.2476",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2828 68.729L101.924 54.0394C102.558 53.0698 102.187 51.7558 101.137 51.2664L100.014 50.7408C99.1088 50.324 98.0405 50.6683 97.5517 51.5383L89.0418 66.7444C88.2633 68.1309 89.4311 69.8074 91.0063 69.5536C91.5223 69.4721 91.9931 69.173 92.2828 68.729Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5224 69.8271L70.7996 62.0972C71.3156 60.8738 73.0086 60.7469 73.7056 61.8887L80.2871 72.6998C80.613 73.2344 80.604 73.9141 80.26 74.4397L78.7844 76.7142C78.2955 77.4664 77.2906 77.6839 76.5302 77.2036L68.1471 71.8389C67.4681 71.4129 67.2056 70.5611 67.5224 69.8271Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1955 28.8278C64.1955 28.8278 73.6921 28.8278 77.3585 17.9443C88.8196 13.9751 86.0132 22.0766 86.0132 22.0766C86.0132 22.0766 82.1385 31.1658 87.1267 37.5817C87.1267 37.5817 90.8113 44.4689 81.6225 42.1399C81.6225 42.1399 78.798 35.7965 65.7526 36.8296C65.7526 36.8205 56.4099 32.5795 64.1955 28.8278Z",
    fill: "#F8E6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0297 10.0332C68.7546 10.0332 60.4167 19.2131 60.4167 30.5315C60.4167 41.85 68.7455 51.0299 79.0297 51.0299C89.3049 51.0299 97.6427 41.85 97.6427 30.5315C97.6427 19.2131 89.3139 10.0332 79.0297 10.0332ZM79.0297 43.1459C72.7017 43.1459 67.5776 37.5002 67.5776 30.5315C67.5776 23.5628 72.7017 17.9172 79.0297 17.9172C85.3578 17.9172 90.4818 23.5628 90.4818 30.5315C90.4818 37.5002 85.3578 43.1459 79.0297 43.1459Z",
    fill: "#FEF6EB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2654 32.0695C66.2654 39.0382 71.3893 44.6839 77.7174 44.6839C81.3658 44.6839 84.6067 42.799 86.707 39.8719C84.6791 41.9018 81.9904 43.1433 79.0301 43.1433C72.702 43.1433 67.578 37.4977 67.578 30.529C67.578 27.5838 68.5015 24.8743 70.0405 22.7266C67.732 25.0374 66.2654 28.3632 66.2654 32.0695Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0294 10.0332C73.326 10.0332 68.2201 12.8606 64.8071 17.3191C68.1567 13.7668 72.7014 11.5738 77.7167 11.5738C87.9919 11.5738 96.3297 20.7536 96.3297 32.0721C96.3297 37.1106 94.6821 41.7141 91.939 45.2845C95.4516 41.56 97.6424 36.3222 97.6424 30.5315C97.6424 19.204 89.3136 10.0332 79.0294 10.0332Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0297 10.0332C68.7546 10.0332 60.4167 19.2131 60.4167 30.5315C60.4167 41.85 68.7455 51.0299 79.0297 51.0299C89.3049 51.0299 97.6427 41.85 97.6427 30.5315C97.6427 19.2131 89.3139 10.0332 79.0297 10.0332ZM79.0297 43.1459C72.7017 43.1459 67.5776 37.5003 67.5776 30.5315C67.5776 23.5628 72.7017 17.9172 79.0297 17.9172C85.3578 17.9172 90.4818 23.5628 90.4818 30.5315C90.4818 37.5003 85.3578 43.1459 79.0297 43.1459Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.572 34.5128C79.5369 34.5128 81.1298 32.821 81.1298 30.7339C81.1298 28.6469 79.5369 26.9551 77.572 26.9551C75.607 26.9551 74.0142 28.6469 74.0142 30.7339C74.0142 32.821 75.607 34.5128 77.572 34.5128Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4697 34.5128C80.4346 34.5128 82.0275 32.821 82.0275 30.7339C82.0275 28.6469 80.4346 26.9551 78.4697 26.9551C76.5048 26.9551 74.9119 28.6469 74.9119 30.7339C74.9119 32.821 76.5048 34.5128 78.4697 34.5128Z",
    fill: "#F8E6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0583 46.8359C83.2024 47.6696 81.1655 48.1318 79.0381 48.1318C77.5353 48.1318 76.0687 47.9053 74.6926 47.4703",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0049 14.7169C74.1233 13.575 76.5133 12.9316 79.03 12.9316C87.8567 12.9316 95.0086 20.8156 95.0086 30.5301C95.0086 36.1577 92.6095 41.169 88.8706 44.3951",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.948 55.5195C100.948 55.5195 116.129 59.7878 120.602 65.2612L100.948 55.5195Z",
    fill: "#F8E6EB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.948 55.5195C100.948 55.5195 116.129 59.7878 120.602 65.2612",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.827 58.2812L125.725 65.259",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0282 72.7285H48.9104",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M63.133 50.8418H50.1873",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9922 35.0326C60.9922 35.0326 63.5089 49.2238 63.7805 49.5772H50.6265L47.6208 34.1445",
    fill: "#FEF6EB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9922 35.0326C60.9922 35.0326 63.5089 49.2238 63.7805 49.5772H50.6265L47.6208 34.1445",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9189 49.3184C64.0095 49.2187 65.6028 44.7692 65.5123 44.6877C65.4217 44.6061 62.0359 38.8789 62.0359 38.8789L63.9189 49.3184Z",
    fill: "#282750"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1355 82.2698L64.5269 74.2227L74.9198 80.4664L73.5709 82.2698H58.1355Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M102.333 68.1612H115.451C115.451 68.1612 115.18 64.3008 109.015 65.3339C104.886 65.3339 95.8967 65.3339 95.8967 65.3339C95.8967 65.3339 100.858 64.4821 102.333 68.1612Z",
    fill: "#F8E6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5274 80.0938L29.3838 102.722L41.3971 108.132L52.9035 80.0938H38.5274Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1283 80.5098H48.8838V81.8238H62.1283V80.5098Z",
    fill: "#FEF6EB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0187 79.6504H48.8835V80.5113H60.0187V79.6504Z",
    fill: "#282750"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9524 80.5098L51.7262 81.8238L50.9114 83.9352L38.4907 81.8238L38.9524 80.5098Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9757 11.7029C69.9757 11.7029 60.2166 11.4673 60.4519 11.7029C60.6873 11.9386 63.1678 10.6608 65.8837 10.4886C68.5996 10.3165 73.1081 10.4886 73.1081 10.4886L71.1435 11.1592",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7417 96.0449C32.5968 96.2805 35.7745 104.953 35.7745 104.953L30.053 102.289L32.7417 96.0449Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4526 31.3125C47.851 31.3125 62.028 44.3981 62.028 44.3981L62.7522 47.6242L48.9012 39.3233L47.4526 31.3125Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7402 23.9264L59.975 30.9676C59.975 30.9676 59.8755 28.394 60.4186 25.8204C56.5802 22.9024 50.6505 19.6582 50.6505 19.6582C50.6505 19.6582 48.7855 22.3406 48.7402 23.9264Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9668 57.0156H56.3789",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4301 81.4381C74.3305 81.2388 63.3945 75.3394 63.3945 75.3394L60.4161 73.8079L50.322 73.5814C50.322 73.5814 49.5253 72.7295 49.7788 72.7295C50.0323 72.7295 62.4892 72.5664 62.4892 72.5664L77.7707 81.8278L74.2491 82.2719L74.4301 81.4381Z",
    fill: "#282750"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5545 70.072H86.3901C86.3901 70.072 88.3275 67.4077 88.3546 67.4984C88.3818 67.589 89.7398 69.2926 89.7398 69.2926L90.5545 70.072Z",
    fill: "#282750"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M55.501 116.461L45.1082 134.549H52.1061L62.4356 116.932L55.1932 116.461",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M123.091 116.461L112.698 134.549H119.696L130.026 116.932L122.783 116.461",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M70.0671 116.461L59.6743 134.549H62.1277L72.4481 116.932L69.7594 116.461",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M134.026 116.463L123.633 134.551H126.086L136.416 116.934L133.718 116.463",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0278 83.9365L44.6184 99.2786L42.4819 104.254L35.3662 89.2107L37.7381 83.5469",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6219 83.1138L40.4021 106.853L41.1445 107.378L51.5554 82.2676",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.542d9432b017036193bbd0613c82dcb8.svg";
export { ForwardRef as ReactComponent };